import React, { useState, useMemo, useContext, useEffect } from "react";
import { useNavigate } from "react-router";
import { Link, NavLink, useLocation } from 'react-router-dom';
import { Col, Row } from "react-bootstrap";
import { getCDNImage } from "../globals";
import Toast from 'react-bootstrap/Toast';
import Screen from '../components/Screen';
import { i18nValue } from '../functions';
import { HotelContext } from "../context/hotel";
import { UserContext } from "../context/user";
import { serviceTypeIcon } from '../globals';
import { T } from "react-translator-component";
import { DoNotDisturb } from "../components/Icons";
import { CheckInContext } from "../context/checkin";
import { isAlvarezArguellez } from "../components/CheckIn/hotelConditions";

const Services = ({ navigation, route }) => {
  const { pathname } = useLocation();
  // const { sections } = useSelector(state => state.hotelReducer);
  const { servicesMenu, sectionsByCode, getUrlPath } = useContext(HotelContext)
  const { doNotDisturb, activeRequestsQty, inactiveRequestsQty, language } = useContext(UserContext)
  const { webCheckInDone, data: checkIn } = useContext(CheckInContext);
  const { data: hotel } = useContext(HotelContext);
  // const { servicesMenu } = useSelector(state => state.hotelReducer?.data?.settings);
  // const { language } = useSelector(state => state.profileReducer);
  const [showAlertNotDisturb, setShowAlertNotDisturb] = useState(false);
  const { inStay } = useContext(UserContext)
  const navigate = useNavigate()
  const items = useMemo(() => {
    let _items = []
    let unsortedKeys = Object.keys(sectionsByCode).filter(i => i.indexOf('service_') !== -1);
    const _keys = servicesMenu && servicesMenu.length > 0 ? servicesMenu : unsortedKeys;
    _keys.map(i => {
      if (sectionsByCode[i]) {
        _items.push(sectionsByCode[i])
        unsortedKeys = unsortedKeys.filter(e => e !== i)
      }
    })
    unsortedKeys.map(i => {
      if (sectionsByCode[i]) {
        _items.push(sectionsByCode[i])
      }
    })
    return _items
  }, [servicesMenu, sectionsByCode])

  useEffect(() => {
    // PARCHE: si la estadia es != in_stay, entonces redirigir a la pantalla de home
    // TODO::: se debe crear un link con tiempo caducable en base a la estadía del huesped
    if (!isAlvarezArguellez(hotel?.id)) return;
    // Preferir status del check-in (ya disponible tras identify) sobre UserContext.inStay (llega async)
    if (checkIn?.status === "in_stay") return;
    if (!checkIn?.id) return;
    navigate(getUrlPath('/home'), { replace: true })
  }, [hotel?.id, checkIn?.id, checkIn?.status, inStay])

  return (
    <Screen
      section="services"
      title={i18nValue(sectionsByCode['services'], 'title', language) || "Services"}
      description={i18nValue(sectionsByCode['services'], 'desc', language)}
    >
      {/* {!webCheckInDone && <Row className="mb-4" style={{ borderTop: "1px solid #EEE", borderBottom: "1px solid #f2e593" }}>
            <Col xs={12} className="text-center pt-3 pb-3" style={{ background: "#fdf9d4" }}>
              <b>IMPORTANTE!</b><br />
              <span className="general-text-sm">Aún no has hecho el WebCheckIn y es un requisito para la estadía, 
              para hacerlo haz click <a className="font-weight-bold" href={getUrlPath("/checkin")}>AQUÍ</a>.</span>
            </Col>
          </Row>} */}

      {(activeRequestsQty + inactiveRequestsQty > 0) && <Row style={{ background: '#FFF', borderBottom: '1px solid #EEE', padding: '10px 10px', marginTop: -9 }}>
        <Col xs="7">
          <b>{activeRequestsQty} {T('general.active')}{activeRequestsQty > 1 ? 's' : ''}</b><small> / {inactiveRequestsQty} {T('general.inactive')}{inactiveRequestsQty > 1 ? 's' : ''}</small>
        </Col>
        <Col xs="5" className="text-right">
          <NavLink to={getUrlPath("/requests")} state={{ from: pathname }} className="general-text-sm">{T('general.go-to-detail')}</NavLink>
        </Col>
      </Row>}

      <Row style={{ marginLeft: 0, marginRight: 0, marginTop: 10 }}>
        {items.map((item) => {
          // TODO::: mejorar esto
          // const _service = sections['service_' + item.code] ?? null;
          // console.log('_service', _service)
          let _title = i18nValue(item, 'title', language) ?? item.title;
          if (_title.trim() === '') {
            _title = item.code.replace('service_', '').replace('_', ' ');
          }

          if (!item.visible) return false;

          const _image = item.image ?? null;
          let _onClick = null;
          let _to = { pathname: item.code, type: item.code };

          if (doNotDisturb) {
            if (item.code !== 'service_donotdisturb') {
              _onClick = (e) => { e.preventDefault(); setShowAlertNotDisturb(true) };
              _to = {};
            }
          }

          return (
            <Col xs="6" lg="4" xl="3" key={item.code} style={{ padding: 10 }} className="service-item">
              <NavLink onClick={_onClick} style={{ opacity: doNotDisturb && item.code !== 'service_donotdisturb' ? 0.3 : 1, color: '#CCC', backgroundColor: '#FFF', display: "block", borderRadius: 10, boxShadow: 'rgb(0 0 0 / 10%) 0px 0px 10px 3px', paddingBottom: 6 }} to={_to} state={{ from: pathname }}>
                {_image && <img src={getCDNImage(_image)} className="service-item-image w-100" style={{ overflow: 'hidden', borderRadius: 8, marginBottom: 4 }} alt='' />}
                {!_image && <div className="service-item-icon w-100 text-center" style={{ paddingTop: 30, height: 160, background: '#FFF', overflow: 'hidden', borderRadius: 15, marginBottom: 4 }}>
                  {serviceTypeIcon(item.code.replace('service_', ''), 90)}
                </div>}
                <div style={{ display: "table", width: '100%' }} className="service-item-label">
                  <span style={{ color: "#333", lineHeight: '18px', display: 'table-cell', fontSize: "16px", verticalAlign: 'middle', height: '30px', padding: '0 8px' }} className="general-text text-center">{_title}</span>
                </div>
              </NavLink>
            </Col>
          )
        })}
      </Row>
      <Toast style={{
        position: 'absolute',
        top: 20,
        right: 30,
        left: 30,
        maxWidth: 'none'
      }} animation={true} onClose={() => setShowAlertNotDisturb(false)} show={showAlertNotDisturb} delay={5000} autohide>
        <Toast.Body className={'text-center'}>
          <DoNotDisturb width={80} height={80} />
          <h6 className="mt-2 text-general-md font-weight-bold">{T("toast.do-not-disturb-mode-active-title")}</h6>
          <p className="general-text-sm">{T("toast.do-not-disturb-mode-active-text")}</p>
          <Link className="general-text-sm" to="service_donotdisturb">{T("toast.do-not-disturb-mode-active-link")}</Link></Toast.Body>
      </Toast>
    </Screen>
  );
}

export default Services;